import { drawChart } from './graph-draw.js';
import { check_svg_mouse_hover, enableGraphZoomableById, getGraphById, transformSVALtoTimescope } from './graph-helpers.js';
import { renderKPIS } from './kpi_unit.js';
import { formatNumberForLocale } from '../../helpers/helpers.js';
// store the drop and rise counts from reduced graph to get info to show on mouse hover
var dropRiseCounts;

var rendered_graphs = [];
// SKIP_WE
// Add a variable string that excludes dates like weekend, nights etc fom ariva data

// draw chart for id number from the alertids
export function drawChartFor(asset_id, el_index) {

	return new Promise(async (resolve, reject) => {

		var graphid = "";

		graphsdata.forEach(function (el, ix) {
			if (el.asset_id == asset_id) {
				graphid = ix;
			}
		})
		//var alertIndexHref = $(this).children("a").attr('href');
		//var alertIndex = alertIndexHref.substring(3);

		var currency = graphsdata[graphid]['currency'] + " ";
		var assetKPIs = graphsdata[graphid]['kpis'];

		renderKPIS(el_index, assetKPIs, currency);

		var sval = graphsdata[graphid]['scale'];

		var timescope = 6;
		timescope = transformSVALtoTimescope(sval);

		if (graphsdata[graphid]['ads'] != 'none') {
			drawChart(
				graphsdata[graphid]['startprice'],
				graphsdata[graphid]['ads'],
				graphsdata[graphid]['preflight'] == 1 ? [] : graphsdata[graphid]['dropGroups'],
				graphsdata[graphid]['preflight'] == 1 ? [] : graphsdata[graphid]['riseGroups'],
				[{}],
				el_index,
				graphsdata[graphid]['dropCount'],
				graphsdata[graphid]['riseCount'],
				graphsdata[graphid]['lastDateForGraph'],
				timescope,
				graphsdata[graphid].assettype)
			.then(dropRiseCounts => {
				// do some mouse features and create svg elements to show on hover
				var svg = $("#visualization_" + el_index).find('svg');

				apendSVGAttributes(svg, el_index);

				svg.attr("id", "svg_" + el_index);

				// create array just for the drops that are visible


				graphsdata[graphid].dropRiseCounts = fillDropRiseCounts(dropRiseCounts);

				registerPriceFlagMouseEvents(el_index);

				// transform client space to svg space and get the mouse pos
				registerDropRiseFlagsMouseEvents(el_index, asset_id);

				resolve();
			}).catch((e) => {
				console.log(e);
				reject(e);
			});
		} else {
			var container = document.getElementById('visualization_' + el_index);
			container.innerHTML = "Keine Graph-Daten verfügbar!";
			resolve();
		}
	}).catch((e) => {
		console.log(e);
	})
}


export function apendSVGAttributes(svg, el_index) {
	svg.css("cursor", "crosshair");
	var txt = document.createElementNS("http://www.w3.org/2000/svg", 'text');
	var txtbg = document.createElementNS("http://www.w3.org/2000/svg", 'rect');

	var line = document.createElementNS("http://www.w3.org/2000/svg", 'line');
	var linetxt = document.createElementNS("http://www.w3.org/2000/svg", 'text');
	var linetxt2 = document.createElementNS("http://www.w3.org/2000/svg", 'text');
	var linetxtbg = document.createElementNS("http://www.w3.org/2000/svg", 'rect');

	txt.setAttributeNS(null, 'x', '2000');
	txt.setAttributeNS(null, 'y', '400');
	txt.setAttributeNS(null, 'font-size', '12');

	linetxt.setAttributeNS(null, 'x', '-2000');
	linetxt.setAttributeNS(null, 'y', '0');
	linetxt.setAttributeNS(null, 'font-size', '12');

	linetxt2.setAttributeNS(null, 'x', '-2000');
	linetxt2.setAttributeNS(null, 'y', '0');
	linetxt2.setAttributeNS(null, 'font-size', '12');

	txtbg.setAttributeNS(null, 'x', '2000');
	txtbg.setAttributeNS(null, 'y', '400');
	txtbg.setAttributeNS(null, 'width', '0');
	txtbg.setAttributeNS(null, 'height', '40');

	linetxtbg.setAttributeNS(null, 'x', '-2000');
	linetxtbg.setAttributeNS(null, 'y', '0');
	linetxtbg.setAttributeNS(null, 'width', '0');
	linetxtbg.setAttributeNS(null, 'height', '80');

	line.setAttributeNS(null, 'x1', '-1000');
	line.setAttributeNS(null, 'x2', '-1000');
	line.setAttributeNS(null, 'y1', '0');
	line.setAttributeNS(null, 'y2', '1000');
	line.setAttributeNS(null, 'stroke', 'black');

	txt.innerHTML = "";
	txtbg.innerHTML = "Test";
	txt.setAttributeNS(null, 'id', 'mouse-text_' + el_index);
	txtbg.setAttributeNS(null, 'id', 'mouse-rect_' + el_index);
	line.setAttributeNS(null, 'id', 'mouse-line_' + el_index);
	linetxt.setAttributeNS(null, 'id', 'mouse-linetxt_' + el_index);
	linetxt2.setAttributeNS(null, 'id', 'mouse-linetxt2_' + el_index);
	linetxtbg.setAttributeNS(null, 'id', 'mouse-linetxtbg_' + el_index);

	svg.append(txtbg);
	svg.append(txt);
	svg.append(line);
	svg.append(linetxtbg);
	svg.append(linetxt);
	svg.append(linetxt2);

}


export function fillDropRiseCounts(dropRiseCounts) {
	var dropRises = [];

	if (dropRiseCounts) {
		for (var i = 0; i < dropRiseCounts.length; i++) {
			if (dropRiseCounts[i].group > 4) {
				var _dropRisex = (dropRiseCounts[i].x);
				_dropRisex = _dropRisex.toString();
				var _dropRisex_plus_one = (dropRiseCounts[i + 1].x);
				_dropRisex_plus_one = _dropRisex_plus_one.toString();
				dropRises.push({
					timespan: Math.floor(Math.abs(new Date(_dropRisex_plus_one) - new Date(_dropRisex)) / 1000 / 60 / 60 / 24),
					percent: dropRiseCounts[i + 1].label.content
				});
				i++;
			}
		}

	}

	return dropRises;

}

export function registerPriceFlagMouseEvents(el_index) {
	var targetElemId = el_index;
	var _graph = getGraphById(targetElemId);
	var _svgJS = document.getElementById("svg_" + targetElemId);
	var _pt = _svgJS.createSVGPoint();
	var visElement = $('#visualization_' + targetElemId);

	(function (_svgJS, targetElemId, _pt, _graph, userassets, visElement) {

		visElement.off();
		visElement.on("mousemove", function (event) {

			var props = _graph.obj.getEventProperties(event)

			var loc = 0;
			_pt.x = props.pageX;
			_pt.y = 0;
			var valueattime = _graph.obj.linegraph.groups[0].itemsData.find(function (elem) { if (new Date(elem.x) >= new Date(props.time)) return elem.y });

			loc = _pt.matrixTransform(_svgJS.getScreenCTM().inverse());

			visElement.on('click', function () {
				var this_index = $(this).attr('id').split("_")[1];
				enableGraphZoomableById(this_index);
			})

			if (valueattime) {
				try {
					$("#mouse-linetxtbg_" + targetElemId).attr("y", "20");
					$("#mouse-linetxt_" + targetElemId).attr("y", "35");
					$("#mouse-linetxt2_" + targetElemId).attr("y", "50");
					$("#mouse-linetxt_" + targetElemId).html("<tspan dx='5'>" + formatNumberForLocale(parseFloat(valueattime.y).toFixed(2)) + " " + userassets[targetElemId].currency + "</tspan>");
					$("#mouse-linetxt2_" + targetElemId).html("<tspan dx='5'>" + (props.time.toLocaleString()) + "</tspan>");
					$("#mouse-linetxtbg_" + targetElemId).attr("width", document.getElementById("mouse-linetxt2_" + targetElemId).getBBox().width + 20);
					$("#mouse-linetxtbg_" + targetElemId).attr("height", document.getElementById("mouse-linetxt_" + targetElemId).getBBox().height * 2 + 10);
					$("#mouse-linetxtbg_" + targetElemId).css("stroke-width", "1px");
					$("#mouse-linetxtbg_" + targetElemId).css("stroke", "white");
					$("#mouse-linetxtbg_" + targetElemId).css("fill", "transparent");

					var line_txt_x = loc.x;
					var line_txt_bg_x = loc.x;

					$("#mouse-line_" + targetElemId).attr("x1", loc.x);
					$("#mouse-line_" + targetElemId).attr("x2", loc.x);

					var __width = document.getElementById("mouse-linetxtbg_" + targetElemId).getBBox().width;

					let svgWidth = _svgJS.getElementsByClassName("hidden-graph")[0].getBBox().width;
					if (loc.x > (svgWidth / 2 - _svgJS.style.left.replace('px', ''))) {
						line_txt_x = loc.x - __width - 0
						line_txt_bg_x = loc.x - __width - 0
					}

					$("#mouse-linetxt_" + targetElemId).attr("x", line_txt_x);
					$("#mouse-linetxt2_" + targetElemId).attr("x", line_txt_x);
					$("#mouse-linetxtbg_" + targetElemId).attr("x", line_txt_bg_x);
				} catch (e) { }
			}

		})
	})(_svgJS, targetElemId, _pt, _graph, userassets, visElement);

}

export function registerDropRiseFlagsMouseEvents(el_index, asset_id) {

	var svgJS = document.getElementById("svg_" + el_index);
	var svg = $("#visualization_" + el_index).find('svg');

	(function (svgJS, svg, el_index, asset_id) {
		svg.off();

		svg.on("mousemove", function (e) {

			var pt = svgJS.createSVGPoint();

			var loc = 0;
			pt.x = e.clientX;
			pt.y = e.clientY;
			loc = pt.matrixTransform(svgJS.getScreenCTM().inverse());
			$("#mouse-text_" + el_index).html("");
			$("#mouse-rect_" + el_index).attr("width", "0px");

			// get all svg elements that belong to the drop-counts
			var result_end = false;
			var ms = svgJS.querySelectorAll('.marker-style,.marker-style-rise');
			for (var i = 0; i < ms.length; i++) {
				if (ms[i].tagName == "circle") result_end = true;

				if (!result_end) {
					if ((typeof ms[i].isPointInFill === "function" && ms[i].isPointInFill(loc)) ||
						(typeof ms[i].isPointInFill !== "function" && check_svg_mouse_hover(ms[i].getBBox(), loc))) {

						var gd_ix = 0;
						graphsdata.forEach(function (gd, ix) {
							if (gd.asset_id == asset_id) {
								gd_ix = ix;
							}
						})

						$("#mouse-text_" + el_index).html(graphsdata[gd_ix].dropRiseCounts[i].percent + " in " + graphsdata[gd_ix].dropRiseCounts[i].timespan + " " + I18n["days_lc"]);

						if (loc.x < (svgJS.getElementsByClassName("hidden-graph")[0].getBBox().width / 2 - svgJS.style.left.replace('px', ''))) {
							$("#mouse-text_" + el_index).attr("x", loc.x + 10);
							$("#mouse-rect_" + el_index).attr("x", loc.x);
						} else {
							$("#mouse-text_" + el_index).attr("x", loc.x - document.getElementById("mouse-text_" + el_index).getBBox().width - 10);
							$("#mouse-rect_" + el_index).attr("x", loc.x - document.getElementById("mouse-text_" + el_index).getBBox().width - 20);
						}

						$("#mouse-text_" + el_index).attr("y", loc.y + 3);
						$("#mouse-rect_" + el_index).attr("y", loc.y - document.getElementById("mouse-text_" + el_index).getBBox().height);
						$("#mouse-rect_" + el_index).attr("width", document.getElementById("mouse-text_" + el_index).getBBox().width + 20);
						$("#mouse-rect_" + el_index).attr("height", document.getElementById("mouse-text_" + el_index).getBBox().height + 10);
						$("#mouse-rect_" + el_index).css("stroke-width", "1px");
						$("#mouse-rect_" + el_index).css("stroke", "white");
						$("#mouse-rect_" + el_index).css("fill", "transparent");
					}
				}
			}

			// get the graph line 
			var gs = svgJS.getElementsByClassName("hidden-graph")[0];
			if (!!gs && gs.isPointInStroke(loc)) {
				// placeholder for future use
				$("#mouse-text_" + el_index).html("");
				$("#mouse-text_" + el_index).attr("x", loc.x);
				$("#mouse-text_" + el_index).attr("y", loc.y);
				$("#mouse-rect_" + el_index).attr("width", "0px");
			}
		});


	})(svgJS, svg, el_index, asset_id);
}